export default "__VITE_ASSET__Cq2pnFrT__"